<template>
    <section class="p-6 lg:py-8">
        <div class="m-auto max-w-[920px]">
            <div class="questionnaire static-page">
                <h1 class="font-bold text-3xl text-center w-full py-10">
                    <slot name="title" />
                </h1>
                <div class="static-page-content">
                    <slot name="content" />
                </div>
            </div>
        </div>
    </section>
</template>